export default {
	global: {
		selectItem: 'Maak een keuze…',
		retry: 'Probeer nogmaals',
		ok: 'Ok',
		back: 'Terug',
		developmentMode: 'Ontwikkelingsmodus geactiveerd.',
		errors: {
			connectivity: {
				401: 'Onbevoegd.',
				408: 'Geen verbinding, probeer opnieuw.',
				500: 'Onbekend probleem, probeer opnieuw.',
				unknown: 'Onbekend probleem, probeer opnieuw.',
			},
		},
		offlineWarning: {
			title: 'Geen verbinding met internet',
			description:
				'Je kunt deze actie niet uitvoeren wanneer je offline bent. Zorg dat je verbonden bent met WiFi of een mobiel netwerk en probeer het opnieuw.',
		},
		login: {
			action: 'Login',
		},
		logout: {
			action: 'Uitloggen',
			modal: {
				title: 'Uitloggen',
				description: 'Weet je zeker dat je wil uitloggen?',
				cancel: 'Annuleer',
				confirm: 'Uitloggen',
			},
		},
	},
	screens: {
		about: {
			identification: 'Identificatie',
			appVersion: 'App versie',
			apiVersion: 'Api versie',
			development: {
				copyToClipboard: 'Gekopieerd naar het klembord',
				accessToken: 'Access token',
				startUpTime: 'Opstarttijd',
				tapToCopy: 'Tik om te kopiëren',
			},
		},
		colleagues: {
			all: "Alle collega's",
			inZone: "Collega's in zone",
			noColleaguesTitle: "Nog geen collega's",
			noColleaguesDescription:
				"Geen van je collega's heeft een reservering gemaakt voor de opgegeven reserveringsgegevens.",
		},
		profile: {
			about: 'Over deze app',
			calendarConnect: 'Agenda koppelen',
			calendarConnectSuccessModal: {
				confirm: 'OK',
				description: 'Je agenda is succesvol gekoppeld!',
				title: 'Agenda koppelen',
			},
			calendarDisconnect: 'Agenda ontkoppelen',
			calendarDisconnectModal: {
				cancel: 'Annuleren',
				confirm: 'Ontkoppelen',
				description: 'Weet je zeker dat je je agenda wil ontkoppelen??',
				title: 'Agenda ontkoppelen',
			},
			calendarDisconnectSuccessModal: {
				confirm: 'OK',
				description: 'Je koppeling met je agenda is succesvol verwijderd!',
				title: 'Agenda ontkoppelen',
			},
			reservationPreferences: 'Reserveringsvoorkeuren',
			screenTitle: 'Mijn profiel',
		},
		reservationPreferences: {
			screenTitle: 'Reserveringsvoorkeuren',
			save: 'Opslaan',
			complete: {
				title: 'Je voorkeuren zijn succesvol opgeslagen!',
			},
			timeslot: {
				label: 'Tijdslot',
				from: 'Van',
				to: 'Tot',
				placeholder: 'Kies een starttijd',
				placeholder_2: 'Kies een eindtijd',
			},
			office: {
				error: 'Geen locaties gevonden',
				label: 'Locatie',
				placeholder: 'Kies een locatie',
			},
			floor: {
				error: 'Geen verdiepingen gevoden',
				label: 'Verdieping',
				placeholder: 'Kies een verdieping',
			},
			zone: {
				error: 'Geen zones gevoden',
				label: 'Zone',
				placeholder: 'Kies een zone',
			},
			desk: {
				error: 'Geen plekken gevoden',
				label: 'Plek',
				placeholder: 'Kies een plek',
			},
		},
		reservations: {
			checkIn: 'Inchecken',
			checkOut: 'Uitchecken',
			checkOutModal: {
				cancel: 'Annuleren',
				confirm: 'Uitchecken',
				description: 'Weet je zeker dat je wil uitchecken?',
				title: 'Uitchecken',
			},
			delete: 'Verwijder reservering',
			deleteModal: {
				cancel: 'Annuleren',
				confirm: 'Verwijderen',
				description: 'Weet je zeker dat je deze reservering wil verwijderen?',
				title: 'Reservering verwijderen',
			},
			edit: 'Wijzig reservering',
			noReservationsTitle: 'Nog geen reserveringen',
			noReservationsDescription:
				'Je hebt nog geen reserveringen gemaakt. Alle reserveringen die je maakt zullen op dit scherm tevoorschijn komen.',
			scanQr: 'Scan ticket',
			share: {
				label: 'Deel reservering',
				title: 'Deel reservering',
				message:
					'Ik heb een reservering geplaatst op {{date}}: locatie "{{office}}", verdieping "{{floor}}", zone "{{zone}}" en plek "{{desk}}".',
			},
			today: 'Vandaag',
			tomorrow: 'Morgen',
			title: 'Mijn reserveringen',
			viewColleagues: "Zie aanwezige collega's",
			viewFloorplan: 'Bekijk plattegrond',
			floorplan: 'Plattegrond',
			office: 'Locatie',
			floor: 'Verdieping',
			zone: 'Zone',
			desk: 'Plek',
			limitAlert: {
				title: 'Reserveringslimiet bereikt',
				description:
					'Je hebt je limiet voor toekomstige reserveringen bereikt. Annuleer een bestaande reservering om door te gaan.',
			},
		},
		reservation: {
			submit: {
				label: '{{count}} plekken weergeven',
			},
			dateSelection: {
				label: 'Datum',
				placeholder: 'Kies datum',
			},
			timeslotSelection: {
				label: 'Tijdslot',
				from: 'Van',
				to: 'Tot',
				placeholder: 'Kies een starttijd',
				placeholder_2: 'Kies een eindtijd',
				list: {
					fullDay: 'Hele dag',
					morning: 'Ochtend',
					afternoon: 'Middag',
					other: 'Ander tijdslot',
				},
			},
			officeSelection: {
				error: 'Geen plek beschikbaar',
				label: 'Locatie',
				multipleSelected: '{{count}} geselecteerd',
				placeholder: 'Kies een locatie',
			},
			floorSelection: {
				error: 'Geen plek beschikbaar',
				label: 'Verdieping',
				multipleSelected: '{{count}} geselecteerd',
				placeholder: 'Kies een verdieping',
			},
			zoneSelection: {
				error: 'Geen plek beschikbaar',
				label: 'Zone',
				multipleSelected: '{{count}} geselecteerd',
				placeholder: 'Kies een zone',
			},
			deskSelection: {
				error: 'Geen plek beschikbaar',
				label: 'Plek',
				placeholder: 'Kies een plek',
			},
		},
		reservationFilter: {
			applyFilter: 'Filter toepassen ({{deskCount}} plekken)',
		},
		reservationResults: {
			screenTitle: 'Werkplek reserveren',
			submit: 'Werkplek reserveren',
		},
		reservationComplete: {
			title: 'De door jou gekozen reservering is bevestigd!',
		},
		scanner: {
			screenTitle: 'Checkin Scanner',
			errors: {
				default: 'Er is een onbekende fout opgetreden.',
				400: 'Gescande QR-code is niet geldig.',
				404: 'Geen reservering gevonden.',
			},
		},
		version: {
			reinstall: {
				title: 'Een gloednieuwe app!',
				caption:
					'We hebben CIAO app een nieuw ontwerp gegeven. ✨ Download de nieuwe app om naar kantoor te blijven gaan.',
				button: 'Nu downloaden',
			},
			update: {
				title: 'Nieuwe versie',
				caption:
					'Je huidige CIAO app versie wordt niet meer ondersteund. Werk de app bij om het te kunnen gebruiken.',
				button: 'Nu bijwerken',
			},
		},
	},
};
